import { z } from "zod";

export const schema = z.object({
  section_name: z.string().min(5, "Minimum 5 Characters needed").nonempty(),
});
